/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Err_Tournament_Create_ForbiddenInputs */



/**
* | output |
* | --- |
* | "Only IC, NC, or Prince can create tournaments" |
*
* @param {Err_Tournament_Create_ForbiddenInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const err_tournament_create_forbidden = /** @type {((inputs?: Err_Tournament_Create_ForbiddenInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Err_Tournament_Create_ForbiddenInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Seuls les IC, NC ou Prince peuvent créer des tournois")
	if (locale === "es") return /** @type {LocalizedString} */ ("Solo IC, NC o Prince pueden crear torneos")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Somente IC, NC ou Prince podem criar torneios")
	if (locale === "it") return /** @type {LocalizedString} */ ("Solo IC, NC o Prince possono creare tornei")
	return /** @type {LocalizedString} */ ("Only IC, NC, or Prince can create tournaments")
});